import {
    Box, Flex,
    Heading,
    Text,
    useDisclosure,
    VStack
} from "@chakra-ui/react";
import {PaginationRow, StyledButton} from "../../../components";
import {useState} from "react";
import {ReactComponent as Close} from "../../../assets/icons/close.svg";
import {ReactComponent as Add} from "../../../assets/icons/add.svg";
import {ReactComponent as Arrow} from "../../../assets/icons/arrow_down.svg";
import {ReactComponent as MenuButton} from "../../../assets/icons/menu_button.svg";
import {ReactComponent as Delete} from "../../../assets/icons/profile/delete_icon.svg";
import {ReactComponent as Edit} from "../../../assets/icons/profile/edit.svg";
import {ReactComponent as Sort} from "../../../assets/icons/asc_desc.svg";
import {ReactComponent as Bitcoin} from "../../../assets/icons/bitcoin_icon.svg";
import {ReactComponent as Filter} from "../../../assets/icons/filter.svg";
import {ScreenerTemplates} from "../../../helpers/data-jsons";
import {ScreenerFilterModal} from "../../../components/modals/screener/ScreenerFilterModal";

const Templates = ({setActiveTab}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(8);

    const totalPages = Math.ceil(ScreenerTemplates.length / itemsPerPage);
    const currentItems = ScreenerTemplates.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    return (
        <VStack
            color={'neutral.100'}
            w={'100%'}>
            <Flex
                justifyContent={'space-between'}
                alignItems={'center'}
                borderBottom={'0.8px solid'}
                borderColor={'neutral.1100'}
                p={{base: '16px 10px', md: '11px 0'}}
                w={'100%'}
            >
                <Heading color={'neutral.100'} fontSize={'heading.3xl'}>Templates</Heading>
                <Box
                    onClick={() => setActiveTab('addTemplate')}
                >
                    <StyledButton>Add</StyledButton>
                </Box>

            </Flex>
            <Box
                p={'16px 32px'}
                bg={'neutral.1100'}
                borderRadius={{base: '0', md: '16px'}}
                display={'flex'}
                flexDirection={'column'}
                gap={'16px'}
            >
                <Box
                    w={'full'}
                    display={'flex'}
                    flexWrap={'wrap'}
                    flexDirection={'row'}
                    gap={'24px'}
                >
                    {currentItems.map((item) => (
                        <Box
                            key={item.id}
                            display={'flex'}
                            flexDirection={'column'}
                            gap={'16px'}
                            boxShadow={'0px 4px 4px 0px #00000040'}
                            p={'16px 24px'}
                            borderRadius={'16px'}
                            border={'solid 1px #1C1E24'}
                            m={'auto'}
                            minW={{base: '100%', lg: '400px', "2xl": '500px'}}>
                            <Flex
                                justifyContent={'space-between'}>
                                <Text fontSize={'18px'}
                                      fontWeight={'500'}
                                >{item.title}</Text>
                                <Flex
                                    gap={'8px'}
                                >
                                    <StyledButton
                                        maxHeight={'32px'}
                                        border={'solid 1px #5834A8'}
                                        padding={'8px 6px'}
                                        bg={'transparent'}
                                        maxWidth={'32px'}><Delete/>
                                    </StyledButton>
                                    <StyledButton
                                        maxHeight={'32px'}
                                        border={'solid 1px #5834A8'}
                                        padding={'8px 6px'}
                                        bg={'transparent'}
                                        maxWidth={'32px'}
                                    ><Edit/></StyledButton>
                                </Flex>
                            </Flex>
                            <Flex
                                color={'neutral.500'}
                                justifyContent={'space-between'}
                            >
                                <Text fontSize={'18px'}>Description</Text>
                                <Text fontSize={'18px'}
                                      textAlign={'end'}
                                >{item.description}</Text>
                            </Flex>
                            <Flex
                                color={'neutral.500'}
                                justifyContent={'space-between'}
                            >
                                <Text fontSize={'18px'}>Type</Text>
                                <StyledButton
                                    textTransform={'capitalize'}
                                    fontWeight={'400'}
                                    fontSize={'12px'}
                                    maxWidth={'max-content'}
                                    width={'66px'}
                                    height={'24px'}
                                >{item.type}</StyledButton>
                            </Flex>
                        </Box>
                    ))}

                </Box>
                <PaginationRow
                    pageCount={totalPages}
                    onPageChange={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    onItemsPerPageChange={(newCount) => {
                        setItemsPerPage(newCount);
                        setCurrentPage(0);
                    }}
                />
            </Box>

        </VStack>

    )
}
export default Templates